import {
    Component,
} from "@angular/core";
import { ComponentBase } from "../../../models/ComponentBase";
import {
    DateTimeTba,
    GetProjectDetailsResponse,
    ProjectTerminalStatement,
    TerminalStatement,
    UpsertProjectRequest,
    UserRight,
} from "../../../WebApiClient";
import { FormArray, FormControl, FormGroup, Validators, AbstractControl } from "@angular/forms";
import { ActivatedRoute, Router } from "@angular/router";
import { ProjectService } from "../../../services/project.service";
import { map, switchMap } from "rxjs/operators";
import { ToastService } from "../../../services/toast.service";
import { TerminalStatementService } from "../../../services/terminalstatement.service";
import { Guid } from "../../../models/Guid";
import { LoginService } from "../../../services/login.service";
import { DatePipe } from "@angular/common";

@Component({
    selector: "app-terminal-statement",
    templateUrl: "./terminalstatement.component.html",
    styleUrls: [
        "./terminalstatement.component.scss",
        "../../../style/sidebarLayout.scss",
        "../../../style/project-details.scss",
    ],
    standalone: false,
})
export class TerminalStatementComponent extends ComponentBase {
    project: UpsertProjectRequest = new UpsertProjectRequest();
    projectId: string = "";

    readonly showEdit: boolean;

    constructor(
        private router: Router,
        route: ActivatedRoute,
        public projectService: ProjectService,
        loginService: LoginService
    ) {
        super();

        this.showEdit = loginService.hasRights(UserRight.EditProject);

        let detailsSub = route.params
            .pipe(
                map((params) => params["id"]),
                switchMap((id) => projectService.getProjectDetails(id))
            )
            .subscribe((pd) => this.updateDetails(pd));

        this.subscriptions.push(detailsSub);
    }

    updateDetails(pd: GetProjectDetailsResponse | undefined): void {
        if (!pd) {
            return;
        }

        this.projectId = pd.id;

        let result = new UpsertProjectRequest({
            ...pd,
            projectId: pd.id,
            customerIds: pd.projectCustomers
                .map((pc) => pc.customerId!)
                .filter((cid) => !!cid),
        });

        this.project = result;
    }

    edit(): void {
        this.router.navigateByUrl("/projects/" + this.projectId + "/terminalStatementEdit");
    }
}
